import {createModel} from '@rematch/core';
import {RootModel} from './index';
import {auth, db} from '../../Firebase/main';
import {handlePresence} from '../../Authentication/fb';
import {updateAvatar} from '../../Users/API';
import {IUser} from '../../Constants/Interfaces';


type TAuth = string | null;

export const Auth = createModel<RootModel>()({
    state: null as TAuth,
    reducers: {
        update(state: TAuth, payload: TAuth) {
            return payload;
        },
        reinitialize() {
            return null;
        },
    },
    effects: (dispatch) => ({
        async handleAuth(_, state): Promise<void> {
            auth.onAuthStateChanged(async (user) => {
                if (user) {
                    const {uid} = user;
                    const currentlyOn = state.chats.defaultRoomId;
                    await updateAvatar();
                    await handlePresence(uid, currentlyOn);
                    dispatch.messages.subscribeToPrivateMessages();
                    dispatch.auth.update(uid);

                    db.ref(`users/${uid}`).get().then((userSnap) => {
                        if (userSnap.exists()) {
                            const data = userSnap.val() as IUser;

                            for (let buddyId of data.buddies) {
                                db.ref(`users/${buddyId}`).get().then((buddySnap) => {
                                    if (buddySnap.exists()) {
                                        dispatch.users.updateUsers({[buddyId]: buddySnap.val()});
                                    }
                                });
                            }
                        }
                    });

                }
                else {
                    dispatch.auth.reinitialize();
                }
            });
        },
    }),
});
